import {
  anIdefenseConfig,
  aTaxiiFeed,
  aThreatIntelItemPage,
  aThreatIntelSource,
  aThreatIntelSourcePage,
  aThreatQConfig,
  mockThreatIntelSourcesOperationQuery,
  ThreatIntelSourceType,
} from '__generated__';

export const CUSTOM_THREAT_INTELLIGENCE_SOURCE_DATA = {
  name: `Custom Source ${Date.now()}`,
  description: 'Test description',
  updatedDescription: 'Test description updated',
  indicatorValue: `www.google${Date.now()}.com`,
  indicatorDescription: 'indicator description',
  updatedIndicatorDescription: 'indicator description updated',
};

export const TAXII_FEED_THREAT_INTELLIGENCE_SOURCE_DATA = {
  name: `Taxii Source ${Date.now()}`,
  description: 'Test description',
  updatedDescription: 'Test description updated',
  url: 'www.google.com',
  pollInterval: 200,
};

export const IDEFENCE_FEED_THREAT_INTELLIGENCE_SOURCE_DATA = {
  name: `Idefence Source ${Date.now()}`,
  description: 'Test description',
  updatedDescription: 'Test description updated',
  apiKey: 'newAPiKey',
};

export const THREATQ_THREAT_INTELLIGENCE_SOURCE_DATA = {
  name: `ThreatQ Source ${Date.now()}`,
  description: 'Test description',
  updatedDescription: 'Test description updated',
  baseUrl: 'www.google.com',
  clientId: 'newAPiKey',
  clientSecret: 'secret',
  pollInterval: 20,
};

export const getThreatIntelCustomSourcesOperationQuery = ({
  name,
  description,
}) => {
  return mockThreatIntelSourcesOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSources: aThreatIntelSourcePage({
          hasNextPage: false,
          objects: [
            aThreatIntelSource({
              description: description,
              id: '1',
              items: aThreatIntelItemPage({
                total: 0,
                hasNextPage: false,
                objects: [],
              }),
              name: name,
              sourceType: ThreatIntelSourceType.Custom,
            }),
          ],
          total: 1,
        }),
        threatIntelItemCount: 1,
        threatIntelItemLimit: 20,
      })
    );
  });
};

export const getThreatIntelTaxiiSourcesOperationQuery = ({
  name,
  description,
}) => {
  return mockThreatIntelSourcesOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSources: aThreatIntelSourcePage({
          hasNextPage: false,
          objects: [
            aThreatIntelSource({
              description: description,
              id: '1',
              items: aThreatIntelItemPage({
                total: 0,
              }),
              name: name,
              sourceType: ThreatIntelSourceType.Taxii,
              taxiiFeed: aTaxiiFeed({
                maxLookbackDays: 7,
                url: 'http://besttaxii.com/taxii-discovery-service',
              }),
            }),
          ],
          total: 1,
        }),
        threatIntelItemCount: 1,
        threatIntelItemLimit: 20,
      })
    );
  });
};

export const getThreatIntelIdefenseSourcesOperationQuery = ({
  name,
  description,
  apiKey,
}) => {
  return mockThreatIntelSourcesOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSources: aThreatIntelSourcePage({
          hasNextPage: false,
          objects: [
            aThreatIntelSource({
              description: description,
              id: '1',
              items: aThreatIntelItemPage({
                total: 0,
              }),
              name: name,
              sourceType: ThreatIntelSourceType.Idefense,
              idefenseConfig: anIdefenseConfig({
                apiKey,
                enabled: true,
              }),
            }),
          ],
          total: 1,
        }),
        threatIntelItemCount: 1,
        threatIntelItemLimit: 20,
      })
    );
  });
};

export const getThreatIntelThreatQSourcesOperationQuery = ({
  name,
  description,
  baseUrl,
  clientId,
  pollInterval,
}) => {
  return mockThreatIntelSourcesOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSources: aThreatIntelSourcePage({
          hasNextPage: false,
          objects: [
            aThreatIntelSource({
              description: description,
              id: '1',
              items: aThreatIntelItemPage({
                total: 0,
              }),
              name: name,
              sourceType: ThreatIntelSourceType.Threatq,
              threatQConfig: aThreatQConfig({
                baseUrl,
                clientId,
                pollIntervalMinutes: pollInterval,
                customFiltersJson: '[]',
              }),
            }),
          ],
          total: 1,
        }),
        threatIntelItemCount: 1,
        threatIntelItemLimit: 20,
      })
    );
  });
};

export const getThreatIntelSources_empty = mockThreatIntelSourcesOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSources: {
          __typename: 'ThreatIntelSourcePage',
          hasNextPage: false,
          objects: [],
          total: 0,
        },
        threatIntelItemCount: 0,
        threatIntelItemLimit: 50,
      })
    );
  }
);

export const handlers = [
  mockThreatIntelSourcesOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSources: aThreatIntelSourcePage(),
        threatIntelItemCount: aThreatIntelSourcePage().total,
        threatIntelItemLimit: 1,
      })
    );
  }),
];
